import { useContext } from 'react';
import { SettingsContext } from '../contexts/SettingsContext';
import { SettingsContextProps } from '../@type/settings';

// ----------------------------------------------------------------------

const useSettings = (): SettingsContextProps => useContext(SettingsContext);

export default useSettings;
